import { CardTypes } from 'scenes/common/types';
import moment from 'moment';

const NUMBERS_ONLY_PATTERN = /[!/@#$%^&*A-Za-z ]/g;
const VALID_VISA_NUMBER_PATTERN = /^4[0-9]{12}(?:[0-9]{3})?$/;
const VALID_MASTERCARD_NUMBER_PATTERN = /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/;
const VALID_CARD_MAX_EXPIRY_YEAR = 76;

export const VALID_CARD_NUMBER_LENGTH = 16;
export const CARD_NAME_MAX_LENGTH = 30;
export const CVV_LENGTH = 3;
export const VALID_CARD_NAME_PATTERN = /^[A-Za-z0-9 ]*$/;

const validateLuhnAlgorithm = (cardNumber: string): boolean => {
  let sum = 0;
  let shouldDouble = false;

  for (let i = cardNumber.length - 1; i >= 0; i -= 1) {
    const digit = parseInt(cardNumber.charAt(i), 10);

    if (shouldDouble) {
      let doubledDigit = digit * 2;

      if (doubledDigit > 9) {
        doubledDigit -= 9;
      }
      sum += doubledDigit;
    } else {
      sum += digit;
    }

    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};

const validateCardType = (cardNumber: string, cardType: string): boolean => {
  switch (cardType) {
    case CardTypes.Visa:
      return VALID_VISA_NUMBER_PATTERN.test(cardNumber);
    case CardTypes.Mastercard:
      return VALID_MASTERCARD_NUMBER_PATTERN.test(cardNumber);
    default:
      return false;
  }
};

export const validateCardNumber = (
  cardNumber: string,
  cardType: string
): boolean =>
  cardNumber.length === VALID_CARD_NUMBER_LENGTH &&
  validateLuhnAlgorithm(cardNumber) &&
  validateCardType(cardNumber, cardType);

const stripNonNumbers = (value: string) =>
  value.replace(NUMBERS_ONLY_PATTERN, '');

export const checkDateLength = (value: string): boolean =>
  stripNonNumbers(value).length === 6;

export const validateCardExpiry = (cardExpiry: string): boolean =>
  moment(cardExpiry, 'MMYYYY', false).isSameOrAfter(moment(), 'month') &&
  moment(cardExpiry, 'MMYYYY', false).isSameOrBefore(
    moment().add(VALID_CARD_MAX_EXPIRY_YEAR, 'year'),
    'year'
  );
